const moduleMap = {
	"./Drawer": () => {
		return Promise.all([__webpack_require__.e(248), __webpack_require__.e(928), __webpack_require__.e(914), __webpack_require__.e(683), __webpack_require__.e(319), __webpack_require__.e(997)]).then(() => (() => ((__webpack_require__(15997)))));
	},
	"./Layout": () => {
		return Promise.all([__webpack_require__.e(248), __webpack_require__.e(75), __webpack_require__.e(928), __webpack_require__.e(978), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(683), __webpack_require__.e(9), __webpack_require__.e(319), __webpack_require__.e(677), __webpack_require__.e(698), __webpack_require__.e(620)]).then(() => (() => ((__webpack_require__(72620)))));
	},
	"./AppRoutes": () => {
		return Promise.all([__webpack_require__.e(248), __webpack_require__.e(75), __webpack_require__.e(928), __webpack_require__.e(978), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(683), __webpack_require__.e(9), __webpack_require__.e(319), __webpack_require__.e(677), __webpack_require__.e(259)]).then(() => (() => ((__webpack_require__(4259)))));
	},
	"./DataRepoRouter": () => {
		return Promise.all([__webpack_require__.e(248), __webpack_require__.e(75), __webpack_require__.e(928), __webpack_require__.e(978), __webpack_require__.e(667), __webpack_require__.e(37), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(683), __webpack_require__.e(9), __webpack_require__.e(319), __webpack_require__.e(101), __webpack_require__.e(240)]).then(() => (() => ((__webpack_require__(23240)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});